import { render, staticRenderFns } from "./SideBarRight.vue?vue&type=template&id=ab98e458&scoped=true"
import script from "./SideBarRight.vue?vue&type=script&lang=js"
export * from "./SideBarRight.vue?vue&type=script&lang=js"
import style0 from "./SideBarRight.vue?vue&type=style&index=0&id=ab98e458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab98e458",
  null
  
)

export default component.exports